import apiV2 from '../utils/apiV2'

export const actions = {
  async requestSendQirLead(_, { payload, captchaKey }) {
    const settings = {
      headers: { GoogleCaptchaResponseKey: captchaKey }
    }

    return await this.$fmAxiosV2.post(
      apiV2.marketing.submitQirLead(),
      payload,
      settings
    )
  },
  async requestSendComplianceLead(_, { payload, captchaKey }) {
    const settings = {
      headers: { GoogleCaptchaResponseKey: captchaKey }
    }

    return await this.$fmAxiosV2.post(
      apiV2.marketing.submitComplianceLead(),
      payload,
      settings
    )
  }
}
